<hc-modal>
    <hc-modal-header><span class="icon-left icon-calendar-clock"></span>Schedule Jobs</hc-modal-header>
    <form [formGroup]="scheduleJobsForm">
        <hc-tab-set #tabset direction="horizontal" (selectedTabChange)="onSelectedTabChanged($event)">
            <hc-tab tabTitle="Schedule">
                <div class="cdp-modal-tab-content cdp-fade-in">
                    <cdp-schedule-jobs
                        [(form)]="scheduleJobsForm"
                        [tenantId]="tenantId"
                        scheduleIsRequired="true"
                        [schedules]="schedules"
                    ></cdp-schedule-jobs>
                </div>
            </hc-tab>

            <hc-tab tabTitle="Confirm Jobs">
                <div class="cdp-modal-tab-content cdp-fade-in">
                    <cdp-select-jobs-grid
                        #selectJobsGrid
                        [jobs]="jobs$ | async"
                        [loading]="loadingJobs"
                        [loadingError]="loadingFailed"
                        [settingsStorageKey]="gridMemoryKey"
                        [tenantId]="tenantId"
                        (refreshRequested)="loadJobs()"
                        (jobStatusChanged)="onJobStatusChanged()"
                    >
                        <h4 additionalHeaderControls>
                            Confirm jobs to add to
                            <span
                                *ngIf="scheduleJobsForm.value.scheduleDescription"
                                class="icon-calendar-clock sched-ico"
                            ></span
                            >{{ scheduleJobsForm.value.scheduleDescription || 'schedule' }}:
                        </h4>
                    </cdp-select-jobs-grid>
                    @if (jobsToReassign > 0) {
                        <cdp-job-reassign-warning></cdp-job-reassign-warning>
                    }
                </div>
            </hc-tab>
        </hc-tab-set>

        <hc-modal-footer>
            <span>
                <cdp-select-summary
                    [items]="grid?.selectedJobs"
                    [selectedHiddenRowCount]="selectJobsGrid.hiddenSelectionsCount"
                    tertiaryPropName="scheduleDescription"
                ></cdp-select-summary>
                <cdp-select-jobs-summary
                    [jobs]="grid?.selectedJobs"
                    [scheduleId]="scheduleJobsForm.value.scheduleId"
                ></cdp-select-jobs-summary>
            </span>

            <div>
                <button hc-button buttonStyle="link" (click)="cancel()">Cancel</button>
                <button
                    [disabled]="!scheduleJobsForm.valid || !scheduleIsSelected"
                    *ngIf="selectedTabIndex === 0"
                    hc-button
                    class="next-btn"
                    buttonStyle="primary"
                    title="{{
                        !scheduleJobsForm.valid || !scheduleIsSelected
                            ? 'Select a valid schedule'
                            : 'Continue to job selection'
                    }}"
                    (click)="tabset.selectTab(1)"
                >
                    <span>Next <span class="icon-right icon-chev-right"></span></span>
                </button>

                <button
                    *ngIf="selectedTabIndex === 1"
                    hc-button
                    buttonStyle="primary"
                    type="button"
                    (click)="saveJobsToSched()"
                    [disabled]="
                        !scheduleJobsForm.valid ||
                        !scheduleIsSelected ||
                        saveInProgress ||
                        grid?.selectedJobs?.length === 0
                    "
                    [title]="saveBtnTitle()"
                >
                    <ng-container *ngIf="!saveInProgress"
                        >Save to schedule ({{ grid?.selectedJobs?.length || '0' }})</ng-container
                    >
                    <ng-container *ngIf="saveInProgress">
                        <hc-progress-dots color="light" [isMini]="true" [isCentered]="false"></hc-progress-dots>
                        <div>Saving...</div>
                    </ng-container>
                </button>
            </div>
        </hc-modal-footer>
    </form>
</hc-modal>
